/**
 * SalesMailer
 * SalesMailer
 *
 * OpenAPI spec version: n/a
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/';

import { Authorize } from '../model/authorize';
import { CurrentUser } from '../model/currentUser';
import { JwtToken } from '../model/jwtToken';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SecurityService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Dane aktualnie zalogowanego użytkownika
     *  - __OperationName__: Query - __Path__: /security/current-user - __OperationId__: CurrentUserQuery - __Name__:  - __Method__: GET - __Description__:  - __Summary__: Dane aktualnie zalogowanego użytkownika - __RouteName__: GETCurrentUserQuery - __Hash__: a4a62e4ba1a260898da3dd548e0aa603 - __Input__:  - __Output__: SalesMailer\\Application\\Account\\CurrentUser - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__: CurrentUser - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public currentUserQuery(observe?: 'body', reportProgress?: boolean): Observable<CurrentUser>;
    public currentUserQuery(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CurrentUser>>;
    public currentUserQuery(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CurrentUser>>;
    public currentUserQuery(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CurrentUser>(`${this.basePath}/api/security/current-user`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Autoryzacja w aplikacji
     *  - __Path__: /security/authorize - __OperationName__: Handler - __OperationId__: GoldfingerAuthorizeHandler - __Name__:  - __Method__: POST - __Description__:  - __Summary__: Autoryzacja w aplikacji - __RouteName__: POSTJwtTokenHandler - __Hash__: 17d875d43264aac743486da26e4dcc8a - __Input__: SalesMailer\\Application\\Account\\Authorize - __Output__: NomaSolutions\\API\\Model\\JwtToken - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__: JwtToken - __InputModelName__: Authorize - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public goldfingerAuthorizeHandler(content?: Authorize, observe?: 'body', reportProgress?: boolean): Observable<JwtToken>;
    public goldfingerAuthorizeHandler(content?: Authorize, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JwtToken>>;
    public goldfingerAuthorizeHandler(content?: Authorize, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JwtToken>>;
    public goldfingerAuthorizeHandler(content?: Authorize, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<JwtToken>(`${this.basePath}/api/security/authorize`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Wylogowanie użytkownika
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public logoutHandler(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public logoutHandler(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public logoutHandler(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public logoutHandler(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<any>(`${this.basePath}/api/security/logout`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
